import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SignupDisclaimerModal = ({ onAccept, onCancel, isMobile }) => {
  const [educationalChecked, setEducationalChecked] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);

  const canProceed = educationalChecked && termsChecked;

  const handleAccept = () => {
    if (canProceed) {
      onAccept({
        acknowledgedSimulation: true,
        acceptedTerms: true,
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px',
      overflowY: 'auto'
    }}>
      <div style={{
        background: '#FFFFFF',
        border: '4px solid #333333',
        boxShadow: '8px 8px 0px rgba(0, 0, 0, 0.3)',
        maxWidth: '600px',
        width: '100%',
        padding: isMobile ? '24px' : '32px',
        maxHeight: '90vh',
        overflowY: 'auto',
        margin: '20px 0'
      }}>
        <div style={{
          margin: '0 0 8px 0',
          fontSize: isMobile ? '1.3rem' : '1.6rem',
          fontWeight: '900',
          color: '#333333 !important',
          textAlign: 'center',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          textShadow: 'none !important'
        }}>
          ⚠️ Important: Please Read
        </div>

        <div style={{
          margin: '0 0 24px 0',
          fontSize: isMobile ? '0.85rem' : '0.95rem',
          color: '#666666 !important',
          textAlign: 'center',
          fontWeight: '600',
          textShadow: 'none !important',
          textTransform: 'none'
        }}>
          Before Continuing
        </div>

        {/* Educational Simulation Notice */}
        <div style={{
          marginBottom: '20px',
          padding: '16px',
          background: '#e3f2fd',
          border: '2px solid #1976d2',
          borderRadius: '4px'
        }}>
          <div style={{
            margin: '0 0 8px 0',
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: '800',
            color: '#1565c0 !important',
            textShadow: 'none !important',
            textTransform: 'uppercase'
          }}>
            ✓ Educational Simulation Only
          </div>
          <p style={{
            margin: '0',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            color: '#333333',
            lineHeight: '1.5'
          }}>
            This platform is a stock market <strong>SIMULATOR</strong> for learning purposes only.
            No real money is involved.
          </p>
        </div>

        {/* Not Investment Advice */}
        <div style={{
          marginBottom: '20px',
          padding: '16px',
          background: '#fff3e0',
          border: '2px solid #f57c00',
          borderRadius: '4px'
        }}>
          <div style={{
            margin: '0 0 8px 0',
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: '800',
            color: '#e65100 !important',
            textShadow: 'none !important',
            textTransform: 'uppercase'
          }}>
            ✓ Not Investment Advice
          </div>
          <p style={{
            margin: '0',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            color: '#333333',
            lineHeight: '1.5'
          }}>
            Nothing on this platform - including the AI guide - constitutes financial or investment advice.
            Do not make real investment decisions based on this simulation.
          </p>
        </div>

        {/* Consult Professional */}
        <div style={{
          marginBottom: '20px',
          padding: '16px',
          background: '#f3e5f5',
          border: '2px solid #7b1fa2',
          borderRadius: '4px'
        }}>
          <div style={{
            margin: '0 0 8px 0',
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: '800',
            color: '#6a1b9a !important',
            textShadow: 'none !important',
            textTransform: 'uppercase'
          }}>
            ✓ Consult a Professional
          </div>
          <p style={{
            margin: '0',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            color: '#333333',
            lineHeight: '1.5'
          }}>
            Before investing real money, consult a licensed financial advisor or investment professional.
          </p>
        </div>

        {/* Data Collection */}
        <div style={{
          marginBottom: '24px',
          padding: '16px',
          background: '#e8f5e9',
          border: '2px solid #388e3c',
          borderRadius: '4px'
        }}>
          <div style={{
            margin: '0 0 8px 0',
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: '800',
            color: '#2e7d32 !important',
            textShadow: 'none !important',
            textTransform: 'uppercase'
          }}>
            ✓ Data Collection
          </div>
          <p style={{
            margin: '0',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            color: '#333333',
            lineHeight: '1.5'
          }}>
            We collect your portfolio choices and platform usage to improve the educational experience.
            See our <Link to="/privacy" target="_blank" style={{ color: '#1976d2', textDecoration: 'underline' }}>Privacy Policy</Link>.
          </p>
        </div>

        {/* Checkboxes */}
        <div style={{
          marginBottom: '24px',
          padding: '20px',
          background: '#f5f5f5',
          border: '2px solid #333333',
          borderRadius: '4px'
        }}>
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: '16px',
            cursor: 'pointer',
            fontSize: isMobile ? '0.9rem' : '1rem',
            lineHeight: '1.5',
            color: '#333333'
          }}>
            <input
              type="checkbox"
              checked={educationalChecked}
              onChange={(e) => setEducationalChecked(e.target.checked)}
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                marginTop: '2px',
                cursor: 'pointer',
                flexShrink: 0
              }}
            />
            <span style={{ fontWeight: '600', color: '#333333' }}>
              I confirm I am 16+ and understand this is an educational simulation, not investment advice
            </span>
          </label>

          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            cursor: 'pointer',
            fontSize: isMobile ? '0.9rem' : '1rem',
            lineHeight: '1.5',
            color: '#333333'
          }}>
            <input
              type="checkbox"
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                marginTop: '2px',
                cursor: 'pointer',
                flexShrink: 0
              }}
            />
            <span style={{ fontWeight: '600', color: '#333333' }}>
              I agree to the{' '}
              <Link to="/terms" target="_blank" style={{ color: '#1976d2', textDecoration: 'underline' }}>
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link to="/privacy" target="_blank" style={{ color: '#1976d2', textDecoration: 'underline' }}>
                Privacy Policy
              </Link>
            </span>
          </label>
        </div>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '12px',
          justifyContent: 'center'
        }}>
          <button
            onClick={handleAccept}
            disabled={!canProceed}
            style={{
              padding: '14px 28px',
              fontSize: isMobile ? '1rem' : '1.1rem',
              fontWeight: '900',
              color: '#FFFFFF',
              background: canProceed ? '#28a745' : '#cccccc',
              border: '3px solid #333333',
              boxShadow: canProceed ? '4px 4px 0px #333333' : 'none',
              cursor: canProceed ? 'pointer' : 'not-allowed',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s ease',
              opacity: canProceed ? 1 : 0.6
            }}
            onMouseOver={(e) => {
              if (canProceed) {
                e.target.style.transform = 'translate(2px, 2px)';
                e.target.style.boxShadow = '2px 2px 0px #333333';
              }
            }}
            onMouseOut={(e) => {
              if (canProceed) {
                e.target.style.transform = 'translate(0, 0)';
                e.target.style.boxShadow = '4px 4px 0px #333333';
              }
            }}
          >
            Complete Registration
          </button>

          <button
            onClick={onCancel}
            style={{
              padding: '14px 28px',
              fontSize: isMobile ? '1rem' : '1.1rem',
              fontWeight: '900',
              color: '#333333',
              background: '#FFFFFF',
              border: '3px solid #333333',
              boxShadow: '4px 4px 0px #333333',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translate(2px, 2px)';
              e.target.style.boxShadow = '2px 2px 0px #333333';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translate(0, 0)';
              e.target.style.boxShadow = '4px 4px 0px #333333';
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupDisclaimerModal;
